import { PREVIEW_TRANSFER, REDUCERS } from '../../constants.js';

const initialActionState = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  acdList: [],
  phoneList: [],
  agentList: [],
  acceptedTransfer: null,
  showing: false,
  showData: true,
  transferInProgress: false,
  unnasignByXfer: false,
  mainAgent:''
}

const previewActions = (state = initialActionState, action) => {
  switch (action.type) {
    case PREVIEW_TRANSFER.DATA_CALL_PREVIEW:
      return {...state, 
        previewAction: action.previewAction,
        acdList: action.acdList, 
        phoneList: action.phoneList, 
        agentList: action.agentList 
      }; 
    case PREVIEW_TRANSFER.ON_RESPONSE_TRANSFER:
      return {
        ...state,
        acceptedTransfer: action.isAccepted
      };
    case PREVIEW_TRANSFER.SHOW_ALERT:
      return {
        ...state,
        showing: !state.showing
      };
    case PREVIEW_TRANSFER.SHOW_PREVIEW_DATA:
      return {
        ...state,
        showData: action.show
      };
    case PREVIEW_TRANSFER.SET_AGENT_LIST:
      return {
        ...state,
        agentList: action.agentList
      };
    case PREVIEW_TRANSFER.TRANSFER_IN_PROGRESS:
      return{
        ...state,
        transferInProgress: action.flag
      };
    case PREVIEW_TRANSFER.UNNASIGN_BY_XFER:
      return{
        ...state,
        unnasignByXfer: action.flag.flag,
        mainAgent: action.flag.mainAgent
      }
      
    default:
      return state;
  }
}

export default previewActions;


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_preview_transfer.js